





















import Vue from "vue";
import BlogPost from "@/components/blog/BlogPost.vue";

export default Vue.extend({
  name: "BlogDetail",
  components: {
    BlogPost,
  },
  computed: {
    blogId(): string {
      return this.$route.params.id;
    },
  },
});
